import { css } from 'lit';
export const videoOverlayButtonStyles = css `
    .video-overlay-button::part(base) {
        width: 96px;
        min-height: auto;
        height: 96px;
        background-color: var(--hlx-color-neutral-0);
        border-color: var(--hlx-color-neutral-0);
        box-shadow: 0 0 36px -8px rgba(0, 0, 0, 0.5);
        color: var(--hlx-text-color-default);
        letter-spacing: var(--hlx-text-letter-spacing-loose-1);
        transition: all var(--hlx-motion-duration-default) var(--hlx-motion-easing-in-out);
    }

    .video-overlay-button::part(base):hover {
        border-color: var(--hlx-color-neutral-25);
        background-color: var(--hlx-color-neutral-25);
    }
`;
//# sourceMappingURL=video-overlay-button.styles.js.map